module.exports = __webpack_public_path__ + "img/illustration.9964f874.svg";